import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import OwlCarousel from "react-owl-carousel2";
import {
  Button,
  connect,
  CustomContainer,
  useRouter
} from "../../atoms/DependencyHelper";
import RadioButton from "../../atoms/radioButton/RadioButton";
import ProductDetailPrice from "../../molecules/productDetailPrice/ProductDetailPrice";

import {
  addBundleProductToGuestCart,
  addSimpleProductToGuestCart,
  addConfigurableToGuestCart,
} from "../../../Redux/actions/cartAction";
import {
  syncUserProfile,
  resetSyncUserProfile,
} from "../../../Redux/actions/userProfileAction";
import labels from "../../../config/labels";
import {
  componentResize,
  getCookieValue,
  getAmountOffValue,
  numberFormat,
  showSpinner,
  hideSpinner,
  getLabel,
  componentCheckSize,
  checkStockQuantity,
  handleCartActionFailure, checkIsLowStock,
} from "../../../utils/helperServices";
import * as Analytics from "../../../services/analyticsUtag";
import config from "../../../config/index";
import styles from "./productDetailForm.module.scss";
import PromotionTimer from "../../atoms/promotionTimer/PromotionTimer";
import {
  displayHideUpgradeModal,
  updateUpgradeRedirect,
  checkIfdealQualifies,
  updateJourneyStatus,
  updateSelectedData,
  setDevicePrice,
  fetchCreditFilters,
  updateUnmaskedMsisdn,
} from "../../../Redux/actions/upgradeAction";
import AffordabilityContainer from "../../molecules/affordabilityContainer/AffordabilityContainer";
import { upgradeStages } from "../../../services/upgradeService";
import types from "../../../config/types";
import ProductDetailIndicators from "../productDetailIndicators/ProductDetailIndicators";
import ajaxService from "../../../utils/ajaxServices";
import {DealBuilderContractSearch, DealBuilderContractSearchData } from "../../vaimo/queries";
import {formatPromoData} from "../../vaimo/dealBuilderUtils";
const useIsVisible = (options) => {
  const [isVisible, setIsVisible] = useState(true);
  const ref = useRef();
  useEffect(() => {

    const observer = new IntersectionObserver(([entry]) => {
      setIsVisible(entry.isIntersecting);
    }, options);

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref, options]);

  return [ref, isVisible];
};
const ProductDetailForm = ({
                             productDetails,
                             selectedVariant,
                             currentPrice,
                             oldPrice,
                             discount,
                             addBundleProductToGuestCart,
                             addSimpleProductToGuestCart,
                             addConfigurableToGuestCart,
                             variantDealPrice,
                             buyOption,
                             handleSelectedBuyOption,
                             buyOptions,
                             buyOptionTitle,
                             buyOptionSku,
                             buyOptionId,
                             buyOptionTypeId,
                             optList,
                             handleOptionClick1,
                             date,
                             displayDiscountTimer,
                             selectedOptions,
                             showUpgradeModal,
                             displayHideUpgradeModal,
                             upgradeCheckDone,
                             updateUpgradeRedirect,
                             syncUserProfile,
                             resetSyncUserProfile,
                             triggerCallback,
                             showSnackBarEvent,
                             closeSnackBarEvent,
                             variantDeviceInstallment,
                             checkIfdealQualifies,
                             checkIsDealAffordable,
                             creditFilters,
                             updateJourneyStatus,
                             fetchCreditFilters,
                             eligibleUpgradeList,
                             setDevicePrice,
                             userLoggedIn,
                             journeyStatus,
                             updateUnmaskedMsisdn,
                             upgradeChecksEnabled,
                             promotionTag,
                             showShopCheck,
                             geoLocationIsAllowed,
                             nearestStore,
                             isStoreStockServiceDown
                           }) => {
  const [showModal, setShowModal] = useState(false);
  const [smallMonthlyArray, setSmallMonthlyArray] = useState([]);
  const [bigMonthlyArray, setBigSmallMonthlyArray] = useState([]);
  const [hugeMonthlyArray, setHugeSmallMonthlyArray] = useState([]);
  const [lowestDeal, setLowestDeal] = useState(null);
  const [recommendedPlans, setRecommendedPlans] = useState([]);
  const [recommendedPlans24, setRecommendedPlans24] = useState([]);
  const [recommendedPlans36, setRecommendedPlans36] = useState([]);
  const [recommendedPlans48, setRecommendedPlans48] = useState([]);
  const [features, setFeatures] = useState(false);
  const [selectedMonthlyInfo, setSelectedMonthlyInfo] = useState('48');
  const [qtyValue, setQtyValue] = useState(1);
  const [isInCart, setIsInCart] = useState(false);
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [showAffordModal, setShowAffordModal] = useState(false);
  const [isTimedOut, setTimedOut] = useState(true);
  let infoText = {
    text: "",
    className: "",
  };
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const urlPrefix = config.envConfigs[env].shoppingUrlPrefix;
  const legacyEnv = config.envConfigs[env].legacyEnv;
  const router = useRouter();

  let gqlCallCounter = 0;

  async function featuresCheck() {
    try {
      const featuresResult = await ajaxService.httpGet(
        "featureBaseUrl",
        "",
        "api",
        "features",
      );

      if (featuresResult) {
        setFeatures(featuresResult);
      }
    } catch (e) {
      console.log("deal-details: features : error: ", e)
    }
  }

  const [ref, isVisible] = useIsVisible({
    root: null, // use the document's viewport as the container
    rootMargin: '0px',
    threshold: 1, // trigger when at least 10% of the element is visible
  });

  const [refNewContract, isNewVisible] = useIsVisible({
    root: null, // use the document's viewport as the container
    rootMargin: '0px',
    threshold: 1, // trigger when at least 10% of the element is visible
  });

  const [refUpgrade, isUpgradeVisible] = useIsVisible({
    root: null, // use the document's viewport as the container
    rootMargin: '0px',
    threshold: 1, // trigger when at least 10% of the element is visible
  });

  const initialObject = Object.values(optList);

  if (initialObject && selectedOptions) {
    initialObject.map((key) => {
      Object.keys(key).map((element) => {
        if (element === labels.lbl_internal_storage) {
          if (Object.values(key)[0] && Object.values(key)[0].length === 1) {
            Object.values(key)[0]?.[0]?.label ===
            selectedOptions?.internal_storage
              ? (selectedOptions["internal_storage"] =
                selectedOptions?.internal_storage)
              : (selectedOptions["internal_storage"] =
                Object.values(key)[0]?.[0]?.label);
          } else {
            const result = Object.values(key)[0].find((obj) => {
              return obj.label === selectedOptions[element];
            });

            result && result?.label === selectedOptions[element]
              ? (selectedOptions[element] = selectedOptions[element])
              : (selectedOptions[element] = Object.values(key)[0]?.[0]?.label);
          }
        } else if (element === labels.lbl_screen_size_pixels) {
          if (Object.values(key)[0] && Object.values(key)[0].length === 1) {
            Object.values(key)[0]?.[0]?.label ===
            selectedOptions?.screen_size_pixels
              ? (selectedOptions["screen_size_pixels"] =
                selectedOptions?.screen_size_pixels)
              : (selectedOptions["screen_size_pixels"] =
                Object.values(key)[0]?.[0]?.label);
          } else {
            const result = Object.values(key)[0].find((obj) => {
              return obj.label === selectedOptions[element];
            });

            result && result?.label === selectedOptions[element]
              ? (selectedOptions[element] = selectedOptions[element])
              : (selectedOptions[element] = Object.values(key)[0]?.[0]?.label);
          }
        }
      });
    });
  }

  const getProductforBadge = () => {
    if (selectedVariant) {
      return selectedVariant.product;
    }
    if (productDetails?.__typename === labels.lbl_product_type_bundle) {
      return productDetails?.items[0]?.options[0]?.product;
    }
    if (productDetails?.__typename === labels.lbl_product_typeName_simple) {
      return productDetails;
    }
  };

  const analyticsData = {
    link_type: "o",
    link_name: "shopping: devices: product details: add to cart",
    sales_event: "cart_add",
    sales_order_discount: [getAmountOffValue(productDetails)],
    page_channel: "shopping",
    page_name: "shopping: devices: product details",
    page_master_tab: "personal",
    sales_product_category: [productDetails?.categories[0]?.name],
    sales_product_id: [productDetails?.name],
    sales_product_quantity: [1],
    sales_product_price: [`${currentPrice}`],
    sales_promo_name: promotionTag ? promotionTag : "",
    ...Analytics.getUtagData([
      "visitor_login_status",
      "visitor_subscription_type",
    ]),
  };

  useEffect(() => {
    if (triggerCallback == "productDetailForm") {
      handleAddToCart();
    }
  }, [triggerCallback]);

  useEffect(() => {
    if (selectedMonthlyInfo === '48') {
      setRecommendedPlans(recommendedPlans48);
    } else if (selectedMonthlyInfo === '36') {
      setRecommendedPlans(recommendedPlans36);
    } else {
      setRecommendedPlans(recommendedPlans24);
    }
  }, [selectedMonthlyInfo])

  useEffect(() => {
    featuresCheck();

    if (isInCart) {
      setIsInCart(false);
    }
  }, [productDetails?.sku]);

  useEffect(() => {
    if (showSnackBar) {
      let timer = setTimeout(() => handleSnackBar(), 3000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [showSnackBar]);

  const closeOptions = () => {
    setShowModal(false);
  };

  const isMobile = componentResize();

  const handleScrollToOptions = () => {
    var element = document.querySelector("[class*='radioButton_radio-button']"),
      elementTop = element.getBoundingClientRect().top + window.scrollY;

    // Scroll to the element, minus 160px
    window.scrollTo({
      top: elementTop - 160,
      behavior: 'smooth' // This enables smooth scrolling
    });
  }

  const handleGetDeal = (selectedDeal) => {
    window.location.href = features && features.pdpToDealBuilder ?
      '/shopping/deal-builder/' + productDetails.sku + '&dealSku=' + selectedDeal + '&variantSku=' + selectedVariant.product.sku + '&colorValue=' + selectedVariant.attributes[0].value_index
      : `${urlPrefix}/deal-selection/${productDetails.sku}?id=${getSelectedVariantForDeals()}&buyOption=${buyOptionSku}`;
  }

  const handleChooseDeal = () => {
    window.location.href = features && features.pdpToDealBuilder ?
      '/shopping/deal-builder/' + productDetails.sku + '&variantSku=' + selectedVariant.product.sku + '&colorValue=' + selectedVariant.attributes[0].value_index
      : `${urlPrefix}/deal-selection/${productDetails.sku}?id=${getSelectedVariantForDeals()}&buyOption=${buyOptionSku}`;
  }

  const handleAddToCart = async () => {
    showSpinner();
    closeSnackBarEvent();
    resetSyncUserProfile();
    const cartId = getCookieValue("cart_id");

    const customizable_options =
      buyOptionId && buyOptionTypeId
        ? [
          {
            id: buyOptionId,
            value_string: buyOptionTypeId?.toString(),
          },
        ]
        : [];

    let cartArr, cartResult;

    if (
      productDetails.__typename === labels.lbl_product_typeName_configurable
    ) {
      cartArr = [
        {
          parent_sku: `${productDetails?.sku}`.toString(),
          data: {
            quantity: qtyValue ? qtyValue : labels.lbl_cart_min_product_add_qty,
            sku: `${selectedVariant?.product?.sku}`.toString(),
          },
          customizable_options,
        },
      ];
      cartResult = await addConfigurableToGuestCart(cartId, cartArr);
    }
    if (productDetails.__typename === labels.lbl_product_typeName_simple) {
      cartArr = [
        {
          data: {
            quantity: labels.lbl_cart_min_product_add_qty,
            sku: `${productDetails?.sku}`,
          },
          customizable_options,
        },
      ];
      cartResult = await addSimpleProductToGuestCart(cartId, cartArr);
    }

    if (productDetails.__typename === labels.lbl_product_type_bundle) {
      const bundleOptions = productDetails.items.map((bundle) => {
        const obj = {
          id: bundle.option_id,
          quantity: labels.lbl_cart_min_product_add_qty,
          value: [bundle.options[0].id],
        };

        return obj;
      });
      cartArr = [
        {
          bundle_options: bundleOptions,
          data: {
            sku: `${productDetails?.sku}`.toString(),
            quantity: labels.lbl_cart_min_product_add_qty,
          },
          customizable_options,
        },
      ];

      cartResult = await addBundleProductToGuestCart(cartId, cartArr);
    }

    if (cartResult.status == 422 && gqlCallCounter == 0) {
      handleCartActionFailure(cartResult, handleAddToCart, handleProfileSync);
      gqlCallCounter++;
    } else if (
      cartResult &&
      !cartResult.errors &&
      (!cartResult?.data ||
        cartResult?.data?.addConfigurableProductsToCart ||
        cartResult?.data?.addSimpleProductsToCart ||
        cartResult?.data?.addBundleProductsToCart)
    ) {
      setShowModal(true);
      setShowSnackBar(true);
      if (productDetails.badges_label == types.TYPE_PREORDER) {
        viewCart();
      } else {
        setIsInCart(true);

        if (buyOption.indexOf('once off') > -1) {
          setTimeout(function () {
            setIsInCart(false);
          }, 4000)
        }
      }
      hideSpinner();
      gqlCallCounter = 0;
    } else {
      resetSyncUserProfile();
      showSnackBarEvent();
      hideSpinner();
      window.scrollTo(0, 0);
      gqlCallCounter = 0;
    }
    Analytics.link({
      ...Analytics.getUtagData([
        "page_name",
        "page_channel",
        "page_master_tab",
        "visitor_login_status",
        "visitor_msisdn_hash",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_subscription_type",
        "page_site_section_lvl_1",
        "page_site_section_lvl_2",
        "page_site_section_lvl_3",
        "page_site_section_lvl_4",
      ]),
      ...analyticsData,
    });
  };

  const handleProfileSync = async () => {
    const JWTtoken = getCookieValue("vod-web-auth-token");
    const cartId = getCookieValue("cart_id");
    const pageAction = "productDetailForm";
    syncUserProfile({ JWTtoken, cartId, pageAction });
  };

  const handleSnackBar = () => {
    setShowSnackBar(false);
  };

  let stockFlag;
  if (selectedVariant) {
    stockFlag = checkStockQuantity(selectedVariant?.product);
  } else {
    stockFlag = checkStockQuantity(productDetails);
  }

  const viewCart = () => {
    showSpinner();
    Analytics.link({
      ...analyticsData,
      link_type: "o",
      link_name: "shopping: devices: product details: view cart",
      sales_event: "view cart",
      sales_order_discount: [getAmountOffValue(productDetails)],
    });
    router.push(`${urlPrefix}/cart`).then(() => {
      window.scrollTo(0, 0);
      hideSpinner();
    });
  };

  const handleSelectedColor = (opt, label, optList) => {
    Analytics.link({
      ...Analytics.getUtagData([
        "page_channel",
        "page_master_tab",
        "visitor_login_status",
        "visitor_msisdn_hash",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_subscription_type",
      ]),
      page_tool_event: "use",
      page_tool_name: "shopping: product details: device colour filter",
      filter_query: label,
      page_name: "shopping: devices: product details",
      sales_product_category: [productDetails?.categories[0]?.name],
      sales_product_id: [productDetails?.name],
      ...Analytics.getUtagData([
        "visitor_login_status",
        "visitor_subscription_type",
      ]),
      page_site_section_lvl_1: productDetails?.name,
      page_site_section_lvl_2: "Browse products",
      page_site_section_lvl_3: "Home",
    });

    handleSelectedDeals(opt, label, false);
    handleOptionClick1(Object.keys(opt), label, optList);
  };

  useEffect(() => {
    handleSelectedDeals(false, false, productDetails.variants[0])
  }, []);

  async function handleSelectedDeals(options, selectedLabel, preselectedVariant) {
    var finalVariant, item;

    if (!preselectedVariant) {
      item = options?.color?.find(entry => entry.label === selectedLabel);
      finalVariant = productDetails?.variants.find(variant =>
        variant.attributes.some(attribute => attribute.value_index === item.value_index)
      );
    } else {
      finalVariant = preselectedVariant;
    }
    const plans = finalVariant?.deal_builder_deals ? finalVariant?.deal_builder_deals : productDetails?.deal_builder_deals;

    let result;
    let specialPlans;

    if (plans && plans.length) {
      specialPlans = await ajaxService.fetchGraphQLPOSTRequest(
        DealBuilderContractSearchData,
        {
          filter: {
            sku: {
              in: plans?.toUpperCase().split(',')
            },
            is_deal_product: {
              eq: 1
            },
            is_hidden_product: {
              eq: 0
            }
          }
        }
      );

      if (specialPlans) {
        var array48 = [],
            array24 = [],
            array36 = [];
        setRecommendedPlans(specialPlans.products.items);

        specialPlans.products.items.forEach((item) => {
          if (item.payment_terms_label === "36") {
            array36.push(item);
          } else if (item.payment_terms_label === "24") {
            array24.push(item);
          } else if (item.payment_terms_label === "48") {
            array48.push(item);
          }
        });

        setRecommendedPlans48(array48);
        setRecommendedPlans36(array36);
        setRecommendedPlans24(array24);
      }
    }

    const [ contractResult] = await Promise.all([
      ajaxService.fetchGraphQLPOSTRequest(DealBuilderContractSearch, { name: productDetails.sku })
    ]);

    if (contractResult) {
      result = await ajaxService.fetchGraphQLPOSTRequest(
        DealBuilderContractSearchData,
        {
          filter: {
            sku: {
              in: contractResult?.DealSelection?.deal_skus
            },
            is_deal_product: {
              eq: 1
            },
            is_hidden_product: {
              eq: 0
            }
          }
        }
      );

      if (result) {
        const terms24 = [];
        const terms36 = [];
        const terms48 = [];

        setLowestDeal(result?.products?.items[0]);

        result.products.items.forEach(item => {
          if (item.payment_terms_label === "24") {
            terms24.push(item);
          } else if (item.payment_terms_label === "36") {
            terms36.push(item);
          } else if (item.payment_terms_label === "48") {
            terms48.push(item);
          }
        });

        setSmallMonthlyArray(terms24);
        setBigSmallMonthlyArray(terms36);
        setHugeSmallMonthlyArray(terms48);

        if (!terms48.length) {
          setSelectedMonthlyInfo('36');
        }

        if (!terms36.length) {
          setSelectedMonthlyInfo('24');
        }
      }
    }
  }

  let productCarousel;
  let productCarousel24;
  let productCarousel48;

  const next = () => {
    if (productCarousel) {
      productCarousel.next(600);
    }
  };
  const prev = () => {
    if (productCarousel) {
      productCarousel.prev(600);
    }
  };

  const next24 = () => {
    if (productCarousel24) {
      productCarousel24.next(600);
    }
  };
  const prev24 = () => {
    if (productCarousel24) {
      productCarousel24.prev(600);
    }
  };
  const next48 = () => {
    if (productCarousel48) {
      productCarousel48.next(600);
    }
  };
  const prev48 = () => {
    if (productCarousel48) {
      productCarousel48.prev(600);
    }
  };

  const carouselOptions = {
    autoplay: false,
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    slideBy: 1,
    dots: true,
    items: 1,
    nav: true,
    margin: 16,
    responsive: {
      0: {
        dots: true,
        items: 1
      },
      1024: {
        dots: true,
      }
    }
  };

  const handleSelectOption = (title) => {
    setTimedOut(false)

    setTimeout(function () {
      setTimedOut(true)
    }, 300)

    handleSelectedBuyOption(title)
  }

  const handleContinueShopping = () => {
    closeOptions();
    showSpinner();
    Analytics.link({
      ...Analytics.getUtagData([
        "page_name",
        "page_channel",
        "page_master_tab",
        "sales_product_id",
        "sales_product_price",
        "sales_product_quantity",
        "sales_product_category",
        "visitor_login_status",
        "visitor_msisdn_hash",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_subscription_type",
        "page_site_section_lvl_1",
        "page_site_section_lvl_2",
        "page_site_section_lvl_3",
        "page_site_section_lvl_4",
      ]),
      link_type: "o",
      link_name: "shopping: product details: continue shopping",
    });
    router.push(`${urlPrefix}/products`).then(() => {
      window.scrollTo(0, 0);
      hideSpinner();
    });
  };

  const handleViewCart = () => {
    closeOptions();
    showSpinner();
    Analytics.link({
      ...Analytics.getUtagData([
        "page_name",
        "page_channel",
        "page_master_tab",
        "sales_product_id",
        "sales_product_price",
        "sales_product_quantity",
        "sales_product_category",
        "visitor_login_status",
        "visitor_msisdn_hash",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_subscription_type",
        "page_site_section_lvl_1",
        "page_site_section_lvl_2",
        "page_site_section_lvl_3",
        "page_site_section_lvl_4",
      ]),
      link_type: "o",
      link_name: "shopping: devices: product details: view cart",
    });
    router.push(`${urlPrefix}/cart`).then(() => {
      window.scrollTo(0, 0);
      hideSpinner();
    });
  };

  const getSelectedVariantForDeals = () => {
    let variant =
      selectedVariant && selectedVariant.product.sku
        ? selectedVariant.product.sku
        : productDetails.sku;
    return variant;
  };

  const goToUrl = () => {
    Analytics.link({
      ...Analytics.getUtagData([
        "page_name",
        "page_channel",
        "page_master_tab",
        "sales_product_id",
        "sales_product_price",
        "sales_product_quantity",
        "sales_order_discount",
        "sales_promo_name",
        "sales_product_category",
        "visitor_login_status",
        "visitor_msisdn_hash",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_subscription_type",
        "page_site_section_lvl_1",
        "page_site_section_lvl_2",
        "page_site_section_lvl_3",
        "page_site_section_lvl_4",
      ]),
      link_type: "o",
      link_name: "shopping: devices: product details: get this deal",
    });
    showSpinner();

    const dealRouter = features && features.pdpToDealBuilder ?
    `${urlPrefix}/deal-builder/${
      productDetails.sku
    }?id=${getSelectedVariantForDeals()}&buyOption=${buyOptionSku}` :
    `${urlPrefix}/deal-selection/${
      productDetails.sku
    }?id=${getSelectedVariantForDeals()}&buyOption=${buyOptionSku}`;

    router
      .push(dealRouter)
      .then(() => {
        hideSpinner();
      });
  };
  const handleFindOut = () => {
    displayHideUpgradeModal(!showUpgradeModal);
  };
  const FindWhy = () => {
    return (
      <p>
        You can't upgrade right now.{" "}
        <a onClick={handleFindOut} className={styles["info-link"]}>
          Find out why
        </a>
      </p>
    );
  };

  const getCTAText = () => {
    if (upgradeCheckDone) {
      (infoText.text = labels.upgrade.lbl_prod_upgrade_qualify_info),
        (infoText.icon = `${imagePrefix}/assets/images/icon-info.svg`);
      infoText.className = `${styles["info-black"]}`;
      return promotionTag && promotionTag == types.TYPE_PREORDER
        ? labels.lbl_preorder_now
        : labels.lbl_choose_upgrade_deal;
    } else {
      if (userLoggedIn && eligibleUpgradeList?.length == 0) {
        infoText.text = FindWhy();
        infoText.icon = `${imagePrefix}/assets/images/icon-cross.svg`;
        infoText.className = `${styles["info-red"]}`;
        return promotionTag && promotionTag == types.TYPE_PREORDER
          ? labels.lbl_preorder_now
          : labels.lbl_choose_upgrade_deal;
      } else {
        infoText.text = labels.upgrade.lbl_prod_upgrade_due_info;
        infoText.icon = `${imagePrefix}/assets/images/icon-info.svg`;
        infoText.className = `${styles["info-black"]}`;
        return labels.lbl_do_an_upgrade_check;
      }
    }
  };

  const handleUpgrade = (val) => {
    Analytics.link({
      link_type: "o",
      link_name: `shopping: devices: product details: ${val}`,
      sales_promo_name: promotionTag ? promotionTag : "",
    });
    if (upgradeChecksEnabled) {
      if (val == "Do an upgrade check") {
        setDevicePrice({
          devicePrice: variantDealPrice,
          installment: Number(variantDeviceInstallment), // Need to update
        });
        if (
          !userLoggedIn &&
          upgradeCheckDone === false &&
          journeyStatus == upgradeStages.OTP_ENRTY
        ) {
          //this will only be done if there is a pending upgrade journey from other pages, to make sure that we will start with entering msisdn again
          //See ticket DCEC-13112 issue no. 2
          updateUnmaskedMsisdn("");
          updateJourneyStatus(null, upgradeStages.NUMBER_ENRTY);
        }

        displayHideUpgradeModal(!showUpgradeModal);

        if (userLoggedIn) {
          if (eligibleUpgradeList?.length > 1) {
            updateJourneyStatus(null, upgradeStages.ELIGIBLE_NUMBER_SELECT);
          } else if (eligibleUpgradeList?.length == 1) {
            fetchCreditFilters(eligibleUpgradeList[0]?.msisdn).then(() => {
              updateJourneyStatus(
                eligibleUpgradeList[0]?.resultCode,
                upgradeStages.UPGRADE_RESULT
              );
            });
          }
        }

        const dealRouter = features && features.pdpToDealBuilder ?
          `${urlPrefix}/deal-builder/${
            productDetails.sku
          }?id=${getSelectedVariantForDeals()}&buyOption=${buyOptionSku}`
          :
          `${urlPrefix}/deal-selection/${
            productDetails.sku
          }?id=${getSelectedVariantForDeals()}&buyOption=${buyOptionSku}`;

        updateUpgradeRedirect(dealRouter);
      } else {
        checkAffordability();
      }
    } else {
      showSpinner();
      router
        .push(
          `https://www${legacyEnv}.vodacom.co.za/cloud/shopping/upgrades-check`
        )
        .then(() => {
          hideSpinner();
        });
    }
  };

  const redirectToDealSelection = () => {
    showSpinner();

    const dealRouter =  features && features.pdpToDealBuilder ?
        `${urlPrefix}/deal-builder/${productDetails.sku}?id=${getSelectedVariantForDeals()}&buyOption=${buyOptionSku}` :
        `${urlPrefix}/deal-selection/${productDetails.sku}?id=${getSelectedVariantForDeals()}&buyOption=${buyOptionSku}`;

    router
      .push(dealRouter)
      .then(() => {
        hideSpinner();
      });
  };

  const checkAffordability = () => {
    if (
      creditFilters?.financeIndicator === "Y" &&
      Number(variantDealPrice) > Number(creditFilters?.total_monthly_payment)
    ) {
      setShowAffordModal(true);
    } else if (
      creditFilters?.financeIndicator === "N" &&
      (Number(variantDealPrice) > Number(creditFilters.total_monthly_payment) ||
        Number(variantDeviceInstallment) >
        Number(creditFilters.deviceInstallment))
    ) {
      setShowAffordModal(true);
    } else {
      redirectToDealSelection();
    }
  };

  useEffect(() => {
    if (checkIsDealAffordable && creditFilters?.total_monthly_payment) {
      checkIfdealQualifies(false);
      checkAffordability();
    }
  }, [checkIsDealAffordable]);

  const getSelectedValue = (code) => {
    return Object.entries(selectedOptions).find((val) => val[0] == code)?.[1];
  };
  function checkforDealData(sku, dealData) {
    const disabledSku = [
      labels.lbl_custom_dropdown_deal_option,
      labels.lbl_custom_dropdown_upgrade_option,
      labels.lbl_custom_dropdown_upgrade_option_new_contract,
    ];

    if (
      Array.isArray(dealData) && disabledSku.includes(sku)
    ) {
      if(dealData.length === 0) return true;
      if(dealData[0].min_price === null && dealData[0].deal_installment === null) return true;
      return false;
    }
  }

  const notStickyBar = (notSticky) => {
    if (notSticky) {
      document.body.classList.remove('sticky-bar');
    } else {
      document.body.classList.add('sticky-bar')
    }

    return notSticky;
  }

  return (
    <>
      <div className={styles.desktopSwatchInfo}>
        {productDetails?.configurable_options && (
          <div className={`${styles.desktopSwatchWrapper} ${optList.length > 1 ? 'multipleOptions' : ''}`}>
            {optList.map((opt, index) => (
              <RadioButton
                key={index}
                items={Object.values(opt)[0]}
                handleOnChange={(label) =>
                  handleSelectedColor(opt, label, optList)
                }
                selectedOption={
                  selectedOptions && getSelectedValue(Object.keys(opt))
                }
                label={getLabel(
                  productDetails.configurable_options,
                  Object.keys(opt)
                )}
              />
            ))}
          </div>
        )}

        <ProductDetailIndicators
          flag
          className={styles.ProductIndicators}
          isLowStock={checkIsLowStock(getProductforBadge())}
          isOutOfStock={checkStockQuantity(
            selectedVariant?.product
              ? selectedVariant?.product
              : productDetails
          )}
          quantity={
            selectedVariant
              ? selectedVariant?.product?.quantity
              : productDetails?.quantity
          }
          showShopCheck={showShopCheck}
          showModal={showModal}
          productDetails={productDetails}
          stockMessage={
            selectedVariant?.product?.stock_message ||
            productDetails?.stock_message
          }
          selectedOption={buyOptionSku}
          isBuyOptioon={buyOptions?.length > 0 ? true : false}
          uniqueIndicationId={`${productDetails?.sku}-Indication`}
          geoLocationIsAllowed={geoLocationIsAllowed}
          promotionTag={promotionTag}
          nearestStore={nearestStore}
          isStoreStockServiceDown={isStoreStockServiceDown}
        />
      </div>

      <div className={styles.itemSwitcherWrapper}>
        {buyOptions?.length ? (
          buyOptions?.map((option, index) => (
            <div
              key={index}
              onClick={() => handleSelectOption(option?.title)}
              className={`${styles.itemSwitcher} ${option?.sku} ${
                checkforDealData(option?.sku, productDetails?.deal_data)
                  ? styles["disabled"]
                  : ""
              }
            ${
                option?.title === buyOption ? styles["active"] : ""
              }`}
            >
              <input
                type="radio"
                name="contract-type"
                checked={buyOption === option.title}
                id={`contract-type-${index}`}
                disabled={checkforDealData(
                  option?.sku,
                  productDetails?.deal_data
                )}
                className={"hidden"}
              />
              <label htmlFor={`contract-type-${index}`}>{
                option?.sku === 'once-off' ? 'Once-off' : option?.sku === 'upgrade' ? 'Upgrade' : 'New contract'
              }</label>
            </div>
          ))
        ) : (
          <></>
        )}
      </div>

      <div className={`${styles.addInfoWrapper} ${buyOption !== "Get this product on a new contract" ? 'roundedLeft' : 'new-contract'}`}>
        {(buyOptionSku === labels.lbl_custom_dropdown_prepaid_option ||
          !buyOptions) && (
          <ProductDetailPrice
            amount={currentPrice}
            prevAmount={oldPrice}
            saveAmount={discount}
            className={styles.textWhite}
            label="Buy it today for only:"
          />
        )}
        {(buyOptionSku == labels.lbl_custom_dropdown_deal_option ||
          buyOptionSku === labels.lbl_custom_dropdown_upgrade_option ||
          buyOptionSku ===
          labels.lbl_custom_dropdown_upgrade_option_new_contract) &&
        variantDealPrice ? (
          <div>
            <div className={styles.monthlySelectorWrapper}>
              {hugeMonthlyArray.length ? (<div data-text="48 Months" onClick={() => setSelectedMonthlyInfo('48')} className={`${styles.monthlySelector} ${selectedMonthlyInfo === '48' ? styles.selectedMonthly : ''}`}><span>48 months</span></div>) : ''}
              {bigMonthlyArray.length ? (<div data-text="36 Months" onClick={() => setSelectedMonthlyInfo('36')} className={`${styles.monthlySelector} ${selectedMonthlyInfo === '36' ? styles.selectedMonthly : ''}`}><span>36 months</span></div>) : ''}
              {smallMonthlyArray.length ? (<div data-text="24 Months" onClick={() => setSelectedMonthlyInfo('24')} className={`${styles.monthlySelector} ${selectedMonthlyInfo === '24' ? styles.selectedMonthly : ''}`}><span>24 months</span></div>) : ''}
            </div>
            <div className={styles.whiteLabel}>Get it on contract starting from</div>
            <p className={styles["deal-price"]}>
              <span className={styles.dealPrice}>
                {hugeMonthlyArray.length || bigMonthlyArray.length ||  smallMonthlyArray.length ?
                  <>
                  {"R"}
                  {(() => {
                    if (selectedMonthlyInfo === '36' && bigMonthlyArray.length) {
                      return (
                        <>
                          {numberFormat(bigMonthlyArray[0].monthly_recurring)}
                          <span>PM x {bigMonthlyArray[0].payment_terms_label}</span>
                        </>
                      )
                    } else if (selectedMonthlyInfo === '48' && hugeMonthlyArray.length) {
                      return (
                        <>
                          {numberFormat(hugeMonthlyArray[0].monthly_recurring)}
                          <span>PM x {hugeMonthlyArray[0].payment_terms_label}</span>
                        </>
                      )
                    } else {
                      return (
                        <>
                          {numberFormat(smallMonthlyArray[0].monthly_recurring)}
                          <span>PM x {smallMonthlyArray[0].payment_terms_label}</span>
                        </>
                      )
                    }
                  })()}
                  </>: 'Loading..'}
              </span>
            </p>
            {(buyOptionSku === labels.lbl_custom_dropdown_deal_option ||
              buyOptionSku === labels.lbl_custom_dropdown_upgrade_option_new_contract) && (
              <div ref={refNewContract} className={`${styles.formActions} ${styles.formActionsContracts}`}>
                <Button
                  variant="danger"
                  className={`${styles.newButton} ${promotionTag && promotionTag == types.TYPE_PREORDER ? styles["preOrderBtn"] : styles["addToCartBtn"]}`}
                  block
                  id={`${productDetails?.sku}-selectDealBtn`}
                  onClick={() => handleChooseDeal()}
                > {promotionTag && promotionTag == types.TYPE_PREORDER
                  ? labels.lbl_preorder_now
                  : 'Next: ' + labels.lbl_select_deal}
                </Button>
              </div>
            )}
            {buyOptionSku &&
              buyOptionSku === labels.lbl_custom_dropdown_upgrade_option && (
                <div ref={refUpgrade} className={`${styles.formActions} ${styles.formActionsContracts}`}>
                  <Button
                    variant="danger"
                    className={`${styles.upgradeButton} ${
                      userLoggedIn && eligibleUpgradeList.length == 0
                        ? styles["disabled"]
                        : styles["addToCartBtn"]
                    }`}
                    block
                    onClick={() => handleUpgrade(getCTAText())}
                  >
                    Next: {getCTAText()}
                  </Button>
                </div>
              )}
          </div>
        ) : (
          ""
        )}

        {displayDiscountTimer ? (
          <PromotionTimer date={date} flag />
        ) : (
          <CustomContainer className="d-lg-block d-md-none" />
        )}
        <div>
          {(buyOptionSku === labels.lbl_custom_dropdown_prepaid_option ||
            !buyOptions) && (
            <div className={`${isInCart ? styles.addedToCartVisible : ''} ${qtyValue === 1 || isInCart ? styles.formActionsWrapperPriceHidden : ''} ${styles.formActionsWrapper}`}>
              <div className={`${styles.qtyInfo} ${qtyValue > 1 || isInCart ? styles.qtyInfoShow : ''}`}>
                Total: <span>R{(qtyValue * currentPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                {isInCart &&
                  <Button
                    variant={
                      "danger"
                    }
                    className={`${styles.viewCartButton} ${promotionTag && promotionTag == types.TYPE_PREORDER ? styles["preOrderBtn"] : styles["addToCartBtn"]}`}
                    block
                    disabled={stockFlag}
                    onClick={handleViewCart}
                    id={`${productDetails?.sku}-AddToCartBtn`}
                  >
                    View my cart
                  </Button>
                }
              </div>
              <div className={`${isInCart ? styles.addedToCartActionVisible : ''} ${qtyValue === 1 ? styles.formActionsPriceHidden : ''} ${styles.formActions}`}>
                <div className={`${styles.qtyWrapper}`}>
                  <button onClick={() => setQtyValue(parseInt(qtyValue) - 1 !== 0 ? parseInt(qtyValue) - 1 : 1)}
                          className={`${qtyValue === 1 || isInCart ? styles.qtyButtonDisabled : ''} ${styles.qtyButton} ${styles.qtyButtonMinus}`}></button>
                  <input className={styles.qtyInput} type={Number} value={qtyValue}/>
                  <button  className={`${isInCart ? styles.qtyButtonDisabled : ''} ${styles.qtyButton} ${styles.qtyButtonPlus}`} onClick={() => setQtyValue(parseInt(qtyValue) + 1)}></button>
                </div>
                <div ref={ref}>
                  <Button
                    variant={
                      promotionTag && promotionTag == types.TYPE_PREORDER
                        ? "danger"
                        : "success"
                    }
                    className={`${promotionTag && promotionTag == types.TYPE_PREORDER ? styles["preOrderBtn"] : styles["addToCartBtnStatic"]} ${styles.addToCartBtnStatic} ${isInCart ? styles.addedToCartBtn : ''}`}
                    block
                    disabled={stockFlag}
                    onClick={handleAddToCart}
                    id={`${productDetails?.sku}-AddToCartBtn`}
                  >
                    {promotionTag && promotionTag == types.TYPE_PREORDER ? (
                      labels.lbl_preorder_now
                    ) : (
                      <>
                        {isInCart ? 'Added to cart' : 'Add to cart'}
                      </>
                    )}
                  </Button>
                </div>
              </div>
              <div className={`${notStickyBar(!isTimedOut || isVisible) ? 'hidden' : styles.sticky_on_mobile}`}>
                <div className={styles.sticky_on_mobile_wrapper}>
                  <div className={styles.productStickyInfo}>
                    <div className={styles.productStickyImage}>
                      <img src={selectedVariant?.product?.thumbnail?.url} width={56} height={56}/>
                    </div>
                    <div className={styles.productStickyDetails}>
                      <div className={styles.productStickyDetailsName}>
                        {selectedVariant?.product?.name}
                      </div>
                      <div className={styles.productStickyDetailsOptions}>
                        {selectedVariant?.attributes[0]?.label}
                        {productDetails?.variants.length > 1 &&
                          <span onClick={() => handleScrollToOptions()} className={styles.productStickyEit}>Edit</span>
                        }
                      </div>
                    </div>
                  </div>
                  <div className={styles.stickyPrice}>
                    <ProductDetailPrice
                      amount={currentPrice < oldPrice ? qtyValue * currentPrice : qtyValue * oldPrice}
                      className="textDark"
                      label="Total"
                    />
                  </div>
                  <div className={`${styles.qtyWrapper} ${styles.qtyWrapperOnWhite}`}>
                    <button onClick={() => setQtyValue(parseInt(qtyValue) - 1 !== 0 ? parseInt(qtyValue) - 1 : 1)}
                            className={`${isInCart ? styles.qtyButtonDisabled : ''} ${qtyValue === 1 ? styles.qtyButtonDisabled : ''} ${styles.qtyButton} ${styles.qtyButtonMinus}`}></button>
                    <input className={styles.qtyInput} type={Number} value={qtyValue}/>
                    <button className={`${isInCart ? styles.qtyButtonDisabled : ''} ${styles.qtyButton} ${styles.qtyButtonPlus}`}
                            onClick={() => setQtyValue(parseInt(qtyValue) + 1)}></button>
                  </div>
                  {isInCart ?
                    <Button
                      variant={
                        "danger"
                      }
                      className={`${styles.viewCartButton} ${styles.addToCartBtn}`}
                      block
                      disabled={stockFlag}
                      onClick={handleViewCart}
                      id={`${productDetails?.sku}-AddToCartBtn`}
                    >
                      View my cart
                    </Button>
                    :
                    <Button
                      variant={
                        promotionTag && promotionTag == types.TYPE_PREORDER
                          ? "danger"
                          : "success"
                      }
                      className={`${promotionTag && promotionTag == types.TYPE_PREORDER ? styles["preOrderBtn"] : styles["addToCartBtn"]} ${styles.addToCartBtn} ${isInCart ? styles.addedToCartBtn : ''}`}
                      block
                      disabled={stockFlag}
                      onClick={handleAddToCart}
                      id={`${productDetails?.sku}-AddToCartBtn`}
                    >
                      {promotionTag && promotionTag == types.TYPE_PREORDER ? (
                        labels.lbl_preorder_now
                      ) : (
                        <>
                          {isInCart ? 'Added to cart' : 'Add to cart'}
                        </>
                      )}
                    </Button>
                  }
                </div>
              </div>
            </div>
          )}
          {buyOptionSku &&
            (buyOptionSku === labels.lbl_custom_dropdown_deal_option ||
              buyOptionSku === labels.lbl_custom_dropdown_upgrade_option_new_contract) && (
              <div className={`${notStickyBar(!isTimedOut || isNewVisible) ? 'hidden' : styles.sticky_on_mobile}`}>
                <div className={styles.sticky_on_mobile_wrapper}>
                  <div className={styles.productStickyInfo}>
                    <div className={styles.productStickyImage}>
                      <img src={selectedVariant?.product?.thumbnail?.url} width={56} height={56}/>
                    </div>
                    <div className={styles.productStickyDetails}>
                      <div className={styles.productStickyDetailsName}>
                        {selectedVariant?.product?.name}
                      </div>
                      <div className={styles.productStickyDetailsOptions}>
                        {selectedVariant?.attributes[0]?.label}
                        {productDetails?.variants.length > 1 &&
                          <span onClick={() => handleScrollToOptions()} className={styles.productStickyEit}>Edit</span>
                        }
                      </div>
                    </div>
                  </div>
                  <div className={styles.stickyPrice}>
                    <div className={styles.priceLabel}>Starting from</div>
                    {(() => {
                      if (selectedMonthlyInfo === '36' && bigMonthlyArray.length) {
                        return (
                          <>
                            <span className={styles.priceBold}>R{numberFormat(bigMonthlyArray[0].monthly_recurring)}</span>
                            <span>PM x {bigMonthlyArray[0].payment_terms_label}</span>
                          </>
                        )
                      } else if (selectedMonthlyInfo === '48' && hugeMonthlyArray.length) {
                        return (
                          <>
                            <span className={styles.priceBold}>R{numberFormat(hugeMonthlyArray[0].monthly_recurring)}</span>
                            <span>PM x {hugeMonthlyArray[0].payment_terms_label}</span>
                          </>
                        )
                      } else if (selectedMonthlyInfo === '24' && smallMonthlyArray.length) {
                        return (
                          <>
                            <span className={styles.priceBold}>R{numberFormat(smallMonthlyArray[0].monthly_recurring)}</span>
                            <span>PM x {smallMonthlyArray[0].payment_terms_label}</span>
                          </>
                        )
                      }
                    })()}
                   </div>
                  <Button
                    variant="danger"
                    className={`${styles.newButton} ${promotionTag && promotionTag == types.TYPE_PREORDER ? styles["preOrderBtn"] : styles["addToCartBtn"]} upgrade-button`}
                    block
                    id={`${productDetails?.sku}-selectDealBtn`}
                    onClick={() => handleChooseDeal()}
                  >
                    {promotionTag && promotionTag === types.TYPE_PREORDER ? '' :
                      <span>Next: </span>}
                    {promotionTag && promotionTag == types.TYPE_PREORDER
                      ? labels.lbl_preorder_now
                      : labels.lbl_select_deal}
                  </Button>
                </div>
              </div>
            )}
          {buyOptionSku &&
            buyOptionSku === labels.lbl_custom_dropdown_upgrade_option && (
              <>
                <div className={`${notStickyBar(!isTimedOut || isUpgradeVisible) ? 'hidden' : styles.sticky_on_mobile}`}>
                  <div className={styles.sticky_on_mobile_wrapper}>
                    <div className={styles.productStickyInfo}>
                      <div className={styles.productStickyImage}>
                        <img src={selectedVariant?.product?.thumbnail?.url} width={56} height={56}/>
                      </div>
                      <div className={styles.productStickyDetails}>
                        <div className={styles.productStickyDetailsName}>
                          {selectedVariant?.product?.name}
                        </div>
                        <div className={styles.productStickyDetailsOptions}>
                          {selectedVariant?.attributes[0]?.label}
                          {productDetails?.variants.length > 1 &&
                            <span onClick={() => handleScrollToOptions()} className={styles.productStickyEit}>Edit</span>
                          }
                        </div>
                      </div>
                    </div>
                    <div className={styles.stickyPrice}>
                      <div className={styles.priceLabel}>Starting from</div>
                      {(() => {
                        if (selectedMonthlyInfo === '36' && bigMonthlyArray.length) {
                          return (
                            <>
                              <span className={styles.priceBold}>R{numberFormat(bigMonthlyArray[0].monthly_recurring)}</span>
                              <span>PM x {bigMonthlyArray[0].payment_terms_label}</span>
                            </>
                          )
                        } else if (selectedMonthlyInfo === '48' && hugeMonthlyArray.length) {
                          return (
                            <>
                              <span className={styles.priceBold}>R{numberFormat(hugeMonthlyArray[0].monthly_recurring)}</span>
                              <span>PM x {hugeMonthlyArray[0].payment_terms_label}</span>
                            </>
                          )
                        } else if (selectedMonthlyInfo === '24' && smallMonthlyArray.length) {
                          return (
                            <>
                              <span className={styles.priceBold}>R{numberFormat(smallMonthlyArray[0].monthly_recurring)}</span>
                              <span>PM x {smallMonthlyArray[0].payment_terms_label}</span>
                            </>
                          )
                        }
                      })()}
                    </div>
                    <Button
                      variant="danger"
                      className={`${styles.newButton} ${
                        userLoggedIn && eligibleUpgradeList.length == 0
                          ? styles["disabled"]
                          : styles["addToCartBtn"]
                      } upgrade-button`}
                      block
                      onClick={() => handleUpgrade(getCTAText())}
                    >
                      <span>Next:</span> {getCTAText()}
                    </Button>
                  </div>
                </div>
              </>
            )}
        </div>
      </div>

      {buyOptionSku === labels.lbl_custom_dropdown_deal_option && recommendedPlans.length ?
        <div className={`${styles.specialOffersWrapper} ${selectedMonthlyInfo === '48' && recommendedPlans48.length === 0 ? 'hidden' : ''} ${selectedMonthlyInfo === '24' && recommendedPlans24.length === 0 ? 'hidden' : ''} ${selectedMonthlyInfo === '36' && recommendedPlans36.length === 0 ? 'hidden' : ''}`}>
          <div className={styles.specialOffersWrapperTitle}>Check out these special offers:</div>
          <div className={styles.carouselWrapper}>
            <OwlCarousel
              ref={(c) => (productCarousel = c)}
              options={carouselOptions}
            >
              {recommendedPlans.map((item, index) => (
                <div data-key={index}
                     className={`${index == 1 ? styles.carouselPlanSpecial : ''} ${styles.carouselPlan}`}
                     key={index}>
                  {index === 1 ? <div className={styles.redHotDeal}>On Promotion</div> : ''}
                  {index === 0 ? <div className={styles.lowestDeal}>Lowest price</div> : ''}
                  {index === 2 ? <div className={styles.betValue}>Best value for money</div> : ''}
                  {index === 1 && <div className={styles.packageWrapperPromotionElement}></div>}
                  <div className={styles.planInner}>
                    <div className={styles.priceWrapper}>
                      R{numberFormat(item.monthly_recurring)}<span>PM x {item.payment_terms_label}</span>
                      {index == 1 && (
                        <p
                          className={`${item.old_monthly_recurring ? 'block' : 'hidden'} ${' min-h-[20px] leading-[20px] text-base font-inter-medium text-[#6D6F81] w-full'}`}>
                          <span>Was R{numberFormat(item.old_monthly_recurring)} PM</span>

                          <span className={styles.youSave}>
                              You save R{item.old_monthly_recurring - item.monthly_recurring}!
                              </span>
                        </p>
                      )}
                    </div>
                    <div className={styles.planOfferItems}>
                      {item?.airtime && (
                        <div className={styles.airtime}><strong>R{item?.airtime}</strong>
                          <div>Airtime</div>
                        </div>
                      )}
                      {item?.promo_data && (
                        <div className={styles.data}><strong>{formatPromoData(item?.promo_data)}</strong>
                          <div>Data</div>
                        </div>
                      )}
                      {item?.minutes_label && (
                        <div className={styles.minutes}>
                          <strong>{item?.minutes_label} {item?.minutes_label !== 'Unlimited' ? 'min' : ''}</strong>
                          <div>Voice</div>
                        </div>
                      )}
                    </div>
                    <div onClick={() => handleGetDeal(item.sku)} className={styles.getThisDeal}>
                      Get this deal
                    </div>
                  </div>
                </div>
              ))}
            </OwlCarousel>
          </div>
        </div>
        : ''
      }

      {showAffordModal && (
        <AffordabilityContainer
          showModal={showAffordModal}
          resultCode={labels.upgrade.errorCodes.code_product_not_affordable}
          toggleModal={() => setShowAffordModal(false)}
        />
      )}
    </>
  );
};

ProductDetailForm.propTypes = {
  selectedVariant: PropTypes.object,
  addToCart: PropTypes.func,
  productDetails: PropTypes.object,
  currentPrice: PropTypes.number,
  oldPrice: PropTypes.number,
  discount: PropTypes.number,
  memoryAttributes: PropTypes.array,
  colorAttributes: PropTypes.array,
  buyOption: PropTypes.string,
  handleSelectedBuyOption: PropTypes.func,
  optList: PropTypes.array,
};

const mapStateToProps = (state) => ({
  showUpgradeModal: state.upgrade.showModal,
  upgradeCheckDone: state.upgrade.upgradeCheckDone,
  checkIsDealAffordable: state.upgrade.checkIsDealAffordable,
  creditFilters: state.upgrade.creditFilters,
  eligibleUpgradeList: state.upgrade.eligibleUpgradeList,
  allUpgradeData: state.upgrade.allUpgradesData,
  userLoggedIn: state.navDetails.isUserLoggedIn,
  journeyStatus: state.upgrade.upgradeStatus,
});

export default connect(mapStateToProps, {
  addBundleProductToGuestCart,
  addSimpleProductToGuestCart,
  addConfigurableToGuestCart,
  syncUserProfile,
  resetSyncUserProfile,
  displayHideUpgradeModal,
  updateUpgradeRedirect,
  checkIfdealQualifies,
  updateJourneyStatus,
  updateSelectedData,
  setDevicePrice,
  fetchCreditFilters,
  updateUnmaskedMsisdn,
})(ProductDetailForm);
